import { headerInitProps } from '@/helper/common/interface';
const types = {
  HEADER_UPDATE: 'update',
  HEADER_UPDATE_THEME: 'updateTheme', //更新主题
  HEADER_UPDATE_TITLE: 'updateTitle', //更新标题
};
interface ActionProps {
  type?: string;
  payload?: any;
}
const initState: headerInitProps = {
  rightContent: '',
  rightClick: undefined,
  theme: 'white',
  title: '',
  isHeader: true,
  className: '',
};

const headerReducer = (state = initState, action: ActionProps = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.HEADER_UPDATE:
    case types.HEADER_UPDATE_THEME:
    case types.HEADER_UPDATE_TITLE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default headerReducer;

export const headerActions = {
  setHeader: function (payload: object) {
    return { type: types.HEADER_UPDATE, payload };
  },
  setTheme: function (payload: object) {
    return { type: types.HEADER_UPDATE, payload };
  },
  setTitle: function (payload: object) {
    return { type: types.HEADER_UPDATE_TITLE, payload };
  },
};
